module.exports = __webpack_public_path__ + "static/img/njCount.4c1515e4.png";